import { render, staticRenderFns } from "./TrainVedio.vue?vue&type=template&id=55ffa9cd&scoped=true"
import script from "./TrainVedio.vue?vue&type=script&lang=js"
export * from "./TrainVedio.vue?vue&type=script&lang=js"
import style0 from "./TrainVedio.vue?vue&type=style&index=0&id=55ffa9cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffa9cd",
  null
  
)

export default component.exports